import { Shield, Trash2, Zap, Server, Lock } from "lucide-react";
import { Link } from "react-router-dom";

export const PrivacySection = () => {
  return (
    <section id="privacy" className="py-20 bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <Shield className="w-12 h-12 mx-auto mb-6 opacity-80" />
          <h2 className="text-3xl font-bold mb-4">Your Privacy is Our Priority</h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            At Maia, we take your email privacy seriously. Our zero-storage policy ensures your data stays secure.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <Trash2 className="w-8 h-8 mx-auto mb-4 opacity-80" />
            <h3 className="font-semibold mb-2">Zero Storage</h3>
            <p className="text-white/80">No emails are ever stored on our servers</p>
          </div>
          <div className="text-center">
            <Zap className="w-8 h-8 mx-auto mb-4 opacity-80" />
            <h3 className="font-semibold mb-2">Immediate Deletion</h3>
            <p className="text-white/80">Generated responses are deleted after delivery</p>
          </div>
          <div className="text-center">
            <Server className="w-8 h-8 mx-auto mb-4 opacity-80" />
            <h3 className="font-semibold mb-2">Secure Servers</h3>
            <p className="text-white/80">Your data remains in your email provider's servers</p>
          </div>
          <div className="text-center">
            <Lock className="w-8 h-8 mx-auto mb-4 opacity-80" />
            <h3 className="font-semibold mb-2">End-to-End Encryption</h3>
            <p className="text-white/80">Complete security in all communications</p>
          </div>
        </div>
        <div className="text-center mt-12">
          <Link 
            to="/privacy-policy" 
            className="text-white/80 hover:text-white underline"
            rel="noopener"
          >
            Check our Privacy Policy page for more information
          </Link>
        </div>
      </div>
    </section>
  );
};